import 'react';

import styled from '@emotion/styled';

import { ResponsiveBreakPoints } from '~/constants/responsive';
import { colors, fontWeight } from '~/styles/constants';

interface Props {
  customFontSize?: string;
}

export default styled('h4')<Props>`
  font-weight: ${fontWeight.medium};
  color: ${colors.fontColor};
  font-size: ${(props) => (props.customFontSize ? props.customFontSize : `0.875rem`)};
  line-height: 1.5rem;
  @media screen and (min-width: ${ResponsiveBreakPoints.ExtraSmallMobile}px) {
    font-size: ${(props) => (props.customFontSize ? props.customFontSize : `1.25rem`)};
  }
  padding: 0;
  margin: 0;
  flex-grow: 1;
`;
